import React, {useEffect, useState} from 'react';
import Grid from "@material-ui/core/Grid";
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Paper from "@material-ui/core/Paper";
import SentenceForm from "./SentenceForm";
import TextField from "@material-ui/core/TextField";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControl from "@material-ui/core/FormControl";
import Radio from "@material-ui/core/Radio";
import clsx from "clsx";
import {useDispatch, useSelector} from "react-redux";
import RentCommercialAddress from "../survey/RentCommercialAddress";
import FormHelperText from "@material-ui/core/FormHelperText";
import {useRecoilState} from "recoil";
import {answerState, rentState} from "../../state/globalState";
import Button from '@material-ui/core/Button'
import AddIcon from '@material-ui/icons/Add'
import RemoveIcon from '@material-ui/icons/Remove'
import { numberToKorean } from '../../utils/numberTokorean'
import { formatWithComma } from '../../utils/utils'

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%'
    },
    formControlLabel: {
        fontFamily: 'Noto Sans KR',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '15px'
    },
    button: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
        borderRadius: 15,
        backgroundColor: "#1b6817",
        padding: '5px 30px',
        height: 35,
        fontSize: "15px",
        color: 'white',
        '&:hover': {
            backgroundColor: '#767676',
            color: '#ffffff'
        }
    },
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#1b6817',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
    addButton: {
      margin: '10px 0',
      backgroundColor: '#1b6817',
      color: 'white',
      '&:hover': {
        backgroundColor: '#767676',
      }
    },
    periodContainer: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: '10px',
      margin: '10px 0',
      flexWrap: 'wrap'
    },
    dateInput: {
      width: '150px'
    },
    datePickerDialog: {
      '& .MuiDialog-paper': {
        padding: '20px'
      }
    },
    date: {
      width: "160px",
      padding: "8px",
      margin: "10px 0"
    },
    buttonContainer: {
      display: 'flex',
      gap: '10px',
      margin: '10px 0'
    },
    deleteButton: {
      margin: '10px 0',
      backgroundColor: '#d32f2f',
      color: 'white',
      '&:hover': {
        backgroundColor: '#767676',
      },
      '&:disabled': {
        backgroundColor: '#cccccc',
        color: '#666666'
      }
    },
  dateFieldBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  dateRangeRow: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: '10px'
  },
  dateRangeSep: {
    paddingBottom: '14px',
    lineHeight: 1
  },
  depositFieldBox: {
    // 데스크탑/기본: 날짜 입력들과 같은 줄
  },
  dateLabel: {
    marginBottom: '4px',
    fontSize: '13px'
  },
  labelRow: {
    display: 'flex',
    alignItems: 'baseline',
    gap: '8px',
    width: '100%'
  },
  amountReadingLabel: {
    fontSize: '12px',
    color: '#666',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    flex: 1,
    minWidth: 0
  },
  amountRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  },
  amountReading: {
    fontSize: '12px',
    color: '#666',
    whiteSpace: 'nowrap'
  },
  defaultAmountReading: {
    fontSize: '12px',
    color: '#666',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '60%',
    position: 'relative',
    top: 10
  },
  [theme.breakpoints.down('sm')]: {
    depositFieldBox: {
      flexBasis: '100%',
      marginTop: '6px'
    }
  }
}));

const CommercialRentAccordion = ({ commercialNo, id, setProcess, history }) => {
    const [answer, setAnswer] = useRecoilState(answerState);
    const [rent, setRent] = useRecoilState(rentState);
    const [isRent, setIsRent] = useState(false);
    const commercial = rent.commercial[id];
    const {validateMode} = answer;
    const classes = useStyles();
  const [rentPeriods, setRentPeriods] = useState([{ startDate: '', endDate: '', rentDepositAmt: '' }]);
  const [expanded, setExpanded] = useState(true);

  useEffect(() => {
    if (rent.commercial[id]?.rentPeriods) {
      setRentPeriods(rent.commercial[id].rentPeriods);
    }
  }, [rent.commercial[id]]);

    // const dispatch = useDispatch();

    // useEffect(() => {
    //     if (commercial.taxAccntYn === "1") {
    //         if (commercial.taxAccntNm === "" || commercial.taxAccntTelno === "") {
    //             dispatch(setValidateResult(false));
    //         }
    //     } else {
    //         if (commercial.rentAgentNm === "" || commercial.rentIncomeAmt === "" || commercial.rentDepositAmt === ""
    //             || commercial.jointYn === "" || (commercial.jointYn === "1" && commercial.shareRate === "")
    //             || commercial.rentAgentZpcd || commercial.rentAgentAddrDetls) {
    //             dispatch(setValidateResult(false));
    //         }
    //     }
    // }, [validateMode]);

    const handleCheckBoxChange = (val) => {
        if (val) {
            const newCommercialCheckList = {
                ...rent,
                commercialChecklist: [
                    ...rent.commercialChecklist,
                    id
                ]
            }
            setRent(newCommercialCheckList);
        } else {
            const newCommercialCheckList = {
                ...rent,
                commercialChecklist: rent.commercialChecklist.filter(item => item !== id)
            }
            setRent(newCommercialCheckList);
        }
        setIsRent(val);
    };

    const handleInputAnswer = (e, column) => {
        const {value, name} = e.target;

        if ("rentIncomeAmt" === column || "rentDepositAmt" === column) {
            const regexp = /\B(?=(\d{3})+(?!\d))/g;
            const onlyNums = value.replace(/[^0-9]/g, '');
            const toNum = Number(onlyNums);

            if (toNum.toString().length <= 12) {
                const replacedValue = toNum.toString().replace(regexp, ',');

                const tmpObj = rent.commercial[id];
                const newCommercialData = {
                    ...tmpObj,
                    [column]: replacedValue
                };

                const newRentData = {
                    ...rent,
                    commercial: {
                        ...rent.commercial,
                        [id]: newCommercialData
                    }
                }
                setRent(newRentData);
            }
        } else if ("shareRate" === column) {
            if (value.length <= 50) {
                const tmpObj = rent.commercial[id];
                const newCommercialData = {
                    ...tmpObj,
                    [column]: value
                };

                const newRentData = {
                    ...rent,
                    commercial: {
                        ...rent.commercial,
                        [id]: newCommercialData
                    }
                }
                setRent(newRentData);
            }
        } else if ("taxAccntNm" === column) {
            if (value.length <= 30) {
                const tmpObj = rent.commercial[id];
                const newCommercialData = {
                    ...tmpObj,
                    [column]: value
                };

                const newRentData = {
                    ...rent,
                    commercial: {
                        ...rent.commercial,
                        [id]: newCommercialData
                    }
                }
                setRent(newRentData);
            }
        } else if ("taxAccntTelno" === column) {
            const onlyNums = value.replace(/[^0-9]/g, '');

            if (onlyNums.length <= 20) {
                const tmpObj = rent.commercial[id];
                const newCommercialData = {
                    ...tmpObj,
                    [column]: onlyNums
                };

                const newRentData = {
                    ...rent,
                    commercial: {
                        ...rent.commercial,
                        [id]: newCommercialData
                    }
                }
                setRent(newRentData);
            }
        } else if ("taxAccntMail" === column) {
          const tmpObj = rent.commercial[id];
          const newHouseData = {
            ...tmpObj,
            [column]: value
          };

          const newRentData = {
            ...rent,
            commercial: {
              ...rent.commercial,
              [id]: newHouseData
            }
          }
          setRent(newRentData);
        } else if ("rentAgentNm" === column) {
            if (value.length <= 50) {
                const tmpObj = rent.commercial[id];
                const newCommercialData = {
                    ...tmpObj,
                    [column]: value
                };

                const newRentData = {
                    ...rent,
                    commercial: {
                        ...rent.commercial,
                        [id]: newCommercialData
                    }
                }
                setRent(newRentData);
            }
        } else if ("rentAgentZpcd" === column) {
            if (value.length <= 6) {
                const tmpObj = rent.commercial[id];
                const newCommercialData = {
                    ...tmpObj,
                    [column]: value
                };

                const newRentData = {
                    ...rent,
                    commercial: {
                        ...rent.commercial,
                        [id]: newCommercialData
                    }
                }
                setRent(newRentData);
            }
        } else if ("rentAgentAddrDetls" === column) {
            if (value.length <= 60) {
                const tmpObj = rent.commercial[id];
                const newCommercialData = {
                    ...tmpObj,
                    [column]: value
                };

                const newRentData = {
                    ...rent,
                    commercial: {
                        ...rent.commercial,
                        [id]: newCommercialData
                    }
                }
                setRent(newRentData);
            }
        } else if ("jointYn" === column) {
            if (value === "0") {
                const tmpObj = rent.commercial[id];
                const newCommercialData = {
                    ...tmpObj,
                    [column]: value,
                    shareRate: ""
                };

                const newRentData = {
                    ...rent,
                    commercial: {
                        ...rent.commercial,
                        [id]: newCommercialData
                    }
                }
                setRent(newRentData);
            } else {
                const tmpObj = rent.commercial[id];
                const newCommercialData = {
                    ...tmpObj,
                    [column]: value
                };

                const newRentData = {
                    ...rent,
                    commercial: {
                        ...rent.commercial,
                        [id]: newCommercialData
                    }
                }
                setRent(newRentData);
            }
        } else if ("taxAccntYn" === column) {
            const tmpObj = rent.commercial[id];

            if (value === "1") {
                const newCommercialData = {
                    ...tmpObj,
                    taxAccntYn: value,
                    rentAgentNm: "",
                    rentIncomeAmt: "",
                    rentDepositAmt: "",
                    jointYn: "",
                    shareRate: "",
                    rentAgentZpcd: "",
                    rentAgentAddr: "",
                    rentAgentAddrDetls: "",
                };

                const newRentData = {
                    ...rent,
                    commercial: {
                        ...rent.commercial,
                        [id]: newCommercialData
                    }
                }
                setRent(newRentData);
            } else {
                const newCommercialData = {
                    ...tmpObj,
                    taxAccntYn: value,
                    taxAccntNm: "",
                    taxAccntTelno: "",
                    taxAccntMail: ""
                };

                const newRentData = {
                    ...rent,
                    commercial: {
                        ...rent.commercial,
                        [id]: newCommercialData
                    }
                }
                setRent(newRentData);
            }
        } else {
            const tmpObj = rent.commercial[id];
            const newCommercialData = {
                ...tmpObj,
                [column]: value
            };

            const newRentData = {
                ...rent,
                commercial: {
                    ...rent.commercial,
                    [id]: newCommercialData
                }
            }
            setRent(newRentData);
        }
    };

    const StyledRadioCommercial = (props) => {
        return (
            <Radio
                disableRipple
                color="default"
                checked={commercial["taxAccntYn"] === props.value}
                checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                icon={<span className={classes.icon} />}
                onChange={(e) => handleInputAnswer(e, 'taxAccntYn')}
                {...props}
            />
        );
    };

    const JointRadio = (props) => {
        return (
            <Radio
                disableRipple
                color="default"
                checked={commercial["jointYn"] === props.value}
                checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                icon={<span className={classes.icon} />}
                onChange={(e) => handleInputAnswer(e, 'jointYn')}
                {...props}
            />
        );
    };

    const handleAddPeriod = () => {
      setRentPeriods([...rentPeriods, { startDate: '', endDate: '' }]);
    };

  const handlePeriodChange = (index, field, value) => {
    let nextValue = value;

    if (field === "rentDepositAmt") {
      const onlyNums = String(value).replace(/[^0-9]/g, "");

      // 빈값 허용
      if (!onlyNums) {
        nextValue = "";
      } else if (onlyNums.length <= 12) {
        // state에는 숫자만 저장
        nextValue = onlyNums;
      } else {
        // 12자리 초과면 기존값 유지
        nextValue = rentPeriods[index]?.rentDepositAmt ?? "";
      }
    }

    const newPeriod = {
      ...rentPeriods[index],
      [field]: nextValue
    };

    const newPeriods = rentPeriods.map((period, i) =>
      i === index ? newPeriod : period
    );

    setRentPeriods(newPeriods);

    const tmpObj = rent.commercial[id];
    const newHouseData = {
      ...tmpObj,
      rentPeriods: newPeriods
    };

    const newRentData = {
      ...rent,
      commercial: {
        ...rent.commercial,
        [id]: newHouseData
      }
    }
    setRent(newRentData);
  };

  const handleDeletePeriod = (e) => {
    e.stopPropagation();
    if (rentPeriods.length > 1) {
      const newPeriods = rentPeriods.slice(0, -1);
      setRentPeriods(newPeriods);

      const tmpObj = rent.commercial[id];
      const newHouseData = {
        ...tmpObj,
        rentPeriods: newPeriods
      };

      const newRentData = {
        ...rent,
        commercial: {
          ...rent.commercial,
          [id]: newHouseData
        }
      }
      setRent(newRentData);
    }
  };

  const handleAccordionChange = (event) => {
    event.stopPropagation();
    setExpanded(!expanded);
  };

    return (
        <React.Fragment>
            <Grid container
                  direction="column"
                  alignItems="flex-start"
                  justifyContent="center"
            >
                <div className={classes.root}>
                    <Accordion
                        expanded={expanded}
                        onChange={handleAccordionChange}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-label="Expand"
                            aria-controls="additional-actions1-content"
                            id="additional-actions1-header"
                        >
                            <FormControlLabel
                                aria-label="Acknowledge"
                                onClick={(event) => event.stopPropagation()}
                                onFocus={(event) => event.stopPropagation()}
                                control={<Checkbox name="commercial-rent-checkbox" checked={isRent} onChange={(e) => handleCheckBoxChange(e.target.checked)} />}
                                label={<Typography className={classes.formControlLabel}>{`[임대 상가${commercialNo}] 상세정보`}</Typography>}
                            />
                        </AccordionSummary>
                        <AccordionDetails>
                            <Paper style={{overflow: 'hidden', padding: '20px'}}>
                                <SentenceForm
                                    title="해당 상가를 개인세무사를 통해 임대소득 및 비용에 관한 장부 작성 및 부가세 신고(상가 임대)를 진행하고 계십니까?"
                                    sentences={[]}
                                    step="23"
                                />
                                <FormControl component="fieldset" style={{margin: '10px 20px 0 25px'}} error={validateMode && commercial.taxAccntYn === ""}>
                                    <RadioGroup defaultValue="0" aria-label="" name="" row>
                                        <FormControlLabel key="commercial-23-1-Y" value="1"
                                                          control={<StyledRadioCommercial />} label="예"/>
                                        <FormControlLabel key="commercial-23-1-N" value="0"
                                                          control={<StyledRadioCommercial />} label="아니오"/>
                                    </RadioGroup>
                                    {(validateMode && commercial.taxAccntYn === "") && <FormHelperText>필수 입력항목입니다.</FormHelperText>}
                                </FormControl>

                                {/* 위 답변이 '예'*/}
                                {commercial.taxAccntYn === "1" && (
                                  <div>
                                    <SentenceForm
                                      title="개인세무사의 성함 및 연락처를 기재 부탁드립니다.<br/>(EY에서 개인세무사님에게 직접 연락하여 임대소득 내용 요청하겠습니다)"
                                      sentences={[]}
                                      step="25-1-1"
                                    />
                                    <div className="textFieldContainer">
                                      <TextField
                                        label="성함"
                                        placeholder=""
                                        margin="none"
                                        onChange={(e) => handleInputAnswer(e, 'taxAccntNm')}
                                        value={commercial.taxAccntNm}
                                        error={validateMode && commercial.taxAccntNm === ''}
                                        helperText={(validateMode && commercial.taxAccntNm === '') && '필수 입력 항목입니다.'}
                                      />
                                    </div>
                                    <div className="textFieldContainer">
                                      <TextField
                                        label="전화번호"
                                        placeholder=""
                                        margin="none"
                                        onChange={(e) => handleInputAnswer(e, 'taxAccntTelno')}
                                        value={commercial.taxAccntTelno}
                                        error={validateMode && commercial.taxAccntTelno === ''}
                                        helperText={(validateMode && commercial.taxAccntTelno === '') && '필수 입력 항목입니다.'}
                                      />
                                    </div>
                                    <div className="textFieldContainer">
                                      <TextField
                                        label="이메일주소"
                                        type="email"
                                        placeholder=""
                                        margin="none"
                                        onChange={(e) => handleInputAnswer(e, 'taxAccntMail')}
                                        value={commercial.taxAccntMail}
                                        error={validateMode && commercial.taxAccntMail === ''}
                                        helperText={(validateMode && commercial.taxAccntMail === '') && '필수 입력 항목입니다.'}
                                      />
                                    </div>
                                  </div>
                                )}


                              {/* 위 답변이 '아니오'*/}
                              {commercial.taxAccntYn === '0' && (
                                <div>
                                  <SentenceForm
                                    title="임대 부동산(사업명) - 사업명이 없는 경우 성함을 기재해주시기 바랍니다."
                                    sentences={[]}
                                    step="25-1-1"
                                  />
                                  <div className="textFieldContainer">
                                    <TextField
                                      label="여기에 답변을 입력하십시오."
                                      placeholder=""
                                      margin="none"
                                      onChange={(e) => handleInputAnswer(e, 'rentAgentNm')}
                                      value={commercial.rentAgentNm}
                                      error={validateMode && commercial.rentAgentNm === ""}
                                      helperText={(validateMode && commercial.rentAgentNm === "") && "필수 입력 항목입니다."}
                                    />
                                  </div>

                                  <RentCommercialAddress id={id}/>
                                  <SentenceForm
                                    title="임대 기간 (보증금이 연중 변경된 경우 변경 전후 기간을 나누어 입력)"
                                    sentences={[]}
                                    step="25-1-1"
                                  />
                                  <div style={{ margin: '0 25px' }}
                                       onClick={(e) => e.stopPropagation()}>
                                    {rentPeriods.map((period, index) => (
                                      <div
                                        key={index}
                                        className={classes.periodContainer}
                                        onClick={(e) => e.stopPropagation()}
                                      >
                                        <div className={classes.dateRangeRow} onClick={(e) => e.stopPropagation()}>
                                          <div className={classes.dateFieldBox} onClick={(e) => e.stopPropagation()}>
                                            <label className={classes.dateLabel}>시작일</label>
                                            <input
                                              className={classes.date}
                                              type="date"
                                              max="9999-12-31"
                                              value={period.startDate}
                                              onChange={(e) => {
                                                e.stopPropagation();
                                                handlePeriodChange(index, 'startDate', e.target.value);
                                              }}
                                              onClick={(e) => e.stopPropagation()}
                                            />
                                          </div>
                                          <span className={classes.dateRangeSep}>~</span>
                                          <div className={classes.dateFieldBox} onClick={(e) => e.stopPropagation()}>
                                            <label className={classes.dateLabel}>종료일</label>
                                            <input
                                              className={classes.date}
                                              type="date"
                                              max="9999-12-31"
                                              value={period.endDate}
                                              onChange={(e) => {
                                                e.stopPropagation();
                                                handlePeriodChange(index, 'endDate', e.target.value);
                                              }}
                                              onClick={(e) => e.stopPropagation()}
                                            />
                                          </div>
                                        </div>
                                        <div className={`${classes.dateFieldBox} ${classes.depositFieldBox}`} onClick={(e) => e.stopPropagation()}>
                                          <div className={classes.labelRow}>
                                            <label className={classes.dateLabel}>임대보증금</label>
                                            {period.rentDepositAmt && (
                                              <span
                                                className={classes.amountReadingLabel}
                                                title={numberToKorean(period.rentDepositAmt)}
                                              >
                                                {numberToKorean(period.rentDepositAmt)}
                                            </span>
                                            )}
                                          </div>
                                          <div className={classes.amountRow}>
                                            <TextField
                                              className={classes.date}
                                              placeholder=""
                                              margin="none"
                                              onChange={(e) => handlePeriodChange(index, 'rentDepositAmt', e.target.value)}
                                              value={formatWithComma(period.rentDepositAmt)}
                                              error={validateMode && period.rentDepositAmt === ""}
                                              helperText={(validateMode && period.rentDepositAmt === "") && "필수 입력 항목입니다."}
                                              inputProps={{
                                                style: { textAlign: "right" },
                                                inputMode: "numeric",
                                              }}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                    <div className={classes.buttonContainer}>
                                      <Button
                                        variant="contained"
                                        className={classes.addButton}
                                        startIcon={<AddIcon/>}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleAddPeriod();
                                        }}
                                      >
                                        기간 추가
                                      </Button>
                                      <Button
                                        variant="contained"
                                        className={classes.deleteButton}
                                        disabled={rentPeriods.length <= 1}
                                        startIcon={<RemoveIcon />}
                                        onClick={handleDeletePeriod}
                                      >
                                        기간 삭제
                                      </Button>
                                    </div>
                                  </div>
                                  <SentenceForm
                                    title="연간 총 임대수입 금액(단위:원) - 분배비율과 관계없이 총 수입금액을 기재 부탁드립니다."
                                    sentences={[]}
                                    step="25-1-1"
                                  />
                                  <div className="textFieldContainer">
                                    <div className={classes.amountRow}>
                                      <TextField
                                        label="여기에 답변을 입력하십시오."
                                        placeholder=""
                                        margin="none"
                                        onChange={(e) => handleInputAnswer(e, 'rentIncomeAmt')}
                                        value={formatWithComma(String(commercial.rentIncomeAmt).replace(/,/g, ''))}
                                        error={validateMode && commercial.rentIncomeAmt === ""}
                                        helperText={(validateMode && commercial.rentIncomeAmt === "") && "필수 입력 항목입니다."}
                                        inputProps={{
                                          style: { textAlign: 'right' },
                                          inputMode: 'numeric'
                                        }}
                                      />
                                      {commercial.rentIncomeAmt && (
                                        <span
                                          className={classes.defaultAmountReading}
                                          style={{ alignSelf: 'center' }}
                                          title={numberToKorean(String(commercial.rentIncomeAmt).replace(/,/g, ''))}
                                        >
                                          {numberToKorean(String(commercial.rentIncomeAmt).replace(/,/g, ''))}
                                        </span>
                                      )}
                                    </div>
                                  </div>

                                  {/*<SentenceForm*/}
                                  {/*  title="임대보증금 (단위 : 원)"*/}
                                  {/*  sentences={[]}*/}
                                  {/*  step="25-1-1"*/}
                                  {/*/>*/}
                                  {/*<div className="textFieldContainer">*/}
                                  {/*  <TextField*/}
                                  {/*    label="여기에 답변을 입력하십시오."*/}
                                  {/*    placeholder=""*/}
                                  {/*    margin="none"*/}
                                  {/*    onChange={(e) => handleInputAnswer(e, 'rentDepositAmt')}*/}
                                  {/*    value={commercial.rentDepositAmt}*/}
                                  {/*    error={validateMode && commercial.rentDepositAmt === ""}*/}
                                  {/*    helperText={(validateMode && commercial.rentDepositAmt === "") && "필수 입력 항목입니다."}*/}
                                  {/*  />*/}
                                  {/*</div>*/}

                                  <SentenceForm
                                    title="공동소유여부"
                                    sentences={[]}
                                    step="25-1-1"
                                  />
                                  <FormControl component="fieldset"
                                               style={{ margin: '10px 20px 0 25px' }}
                                               error={validateMode && commercial.jointYn === ""}>
                                    <RadioGroup defaultValue="0" aria-label="" name="" row>
                                      <FormControlLabel key="commercial-25-1-Y" value="1"
                                                        control={<JointRadio/>} label="예"/>
                                      <FormControlLabel key="commercial-25-1-N" value="0"
                                                        control={<JointRadio/>} label="아니오"/>
                                    </RadioGroup>
                                    {(validateMode && commercial.jointYn === "") &&
                                      <FormHelperText>필수 입력항목입니다.</FormHelperText>}
                                  </FormControl>

                                  {/* 공동소유여부 '예' 일경우 */}
                                  {commercial.jointYn === "1" && (
                                    <div>
                                      <SentenceForm
                                        title="지분비율 혹은 지정된 손익분배비율(예: 본인 60 : 배우자 40)"
                                        sentences={[]}
                                        step="25-1-1"
                                      />
                                      <div className="textFieldContainer">
                                        <TextField
                                          label="여기에 답변을 입력하십시오."
                                          placeholder=""
                                          margin="none"
                                          onChange={(e) => handleInputAnswer(e, 'shareRate')}
                                          value={commercial.shareRate}
                                          error={validateMode && commercial.shareRate === ""}
                                          helperText={(validateMode && commercial.shareRate === "") && "필수 입력 항목입니다."}
                                        />
                                      </div>
                                    </div>
                                  )}
                                </div>
                              )}
                            </Paper>
                        </AccordionDetails>
                    </Accordion>
                </div>
            </Grid>
        </React.Fragment>
    );
};

export default CommercialRentAccordion;
